/**
 * Source of truth: `Delete Account v2 - Desktop.dc.html` and
 * `DeleteAccountScreen.dc.html` (mobile/tablet) in the Inkfree design
 * project. This screen's palette is deliberately its own — the design's
 * `#D64535` danger red is close to, but distinct from, the app's shared
 * `error` tone, so this stays a per-screen token file rather than borrowing
 * the global one (see `PROJECT_RULES.md`). The amber warning colour, by
 * contrast, was byte-identical to `signer.warn.main` and now references it
 * directly instead of repeating the hex.
 */
import { formField, notification, signer } from "theme/colors";

const deleteAccountTokens = {
  color: {
    ink: signer.ink,
    body: signer.text.meta,
    label: signer.text.faint,
    listText: signer.text.secondary,
    danger: "#D64535",
    dangerTile: notification.error.bg,
    dangerArmedBtnBg: "#D64535",
    dangerIdleBtnBg: "#E7B8B2",
    amber: signer.warn.main,
    success: "#1E8A55",
    hairline: signer.surface.muted,
    inputBorder: formField.border,
    inputBg: signer.surface.subtle,
    cardShadow: "0 2px 10px rgba(33,21,71,.05)",
    confirmShadow: "0 8px 28px rgba(33,21,71,.1)",
  },
  radius: {
    tile: "13px",
    card: "16px",
    input: "9px",
  },
  removes: [
    "All signed documents, pending sign requests, templates, and audit trails.",
    "Every active subscription — billing stops and renewals are cancelled.",
    "Access for all users in your organization.",
    "Connected APIs, webhooks, and integrations.",
  ],
  checks: [
    "Download any signed documents and audit trails you want to keep.",
    "Remove Inkfree integrations from your websites and applications.",
  ],
};

export default deleteAccountTokens;
